module.exports = __webpack_public_path__ + "static/img/OrganizationC240129EN.77d64d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OrganizationC240129EN.jpg
// module id = N3fJ
// module chunks = 1